import { useState } from 'react';
import { Form } from 'antd';
import { IWorkflow } from '@/interfaces/ICalendarWorkflows';

export const useWorkflowModal = () => {
	const [form] = Form.useForm();
	const [isVisible, setIsVisible] = useState(false);
	const [isEditing, setIsEditing] = useState(false);
	const [currentWorkflow, setCurrentWorkflow] = useState<IWorkflow | null>(null);

	const openModal = (workflow?: IWorkflow) => {
		setIsVisible(true);

		if (workflow) {
			setIsEditing(true);
			setCurrentWorkflow(workflow);
		} else {
			setIsEditing(false);
			setCurrentWorkflow(null);
		}
	};

	const closeModal = () => {
		setIsVisible(false);
		setIsEditing(false);
		setCurrentWorkflow(null);
		form.resetFields();
	};

	return {
		form,
		isVisible,
		isEditing,
		currentWorkflow,
		openModal,
		closeModal,
	};
};
